<!-- SECTION - taquets -->
<section id="section-taquets">
    <div id="section-taquets-inner">
        <div class="container">
            <h2 class="section-title" *ngIf="title">
                <strong>{{title}}</strong>
            </h2>
            <p class="section-desc" *ngIf="description">{{description}}</p>

            <ul class="personalized-slide-links nav nav-pills" *ngIf="items.length">
              
                <li class="page-nav-item" *ngFor="let item of items; index as index" [class.active]="selected === index">
                  <a class="personalized-slide-link nav-link" (click)="onClickTaquet($event, index)">{{item.button || item.title}}</a>
                </li>

            </ul>

            <span #ref><ng-content select=".taquets-slides"></ng-content></span>
            <div class="taquets-slides" *ngIf="ref.childNodes.length == 0">
                <ng-container *ngFor="let item of items; index as index">
                    <div class="taquets-slide" *ngIf="item.content" [class.active]="selected === index">
                        <h2 class="section-title"><strong>{{item.title}}</strong></h2>
                        <p>{{item.content}}</p>
                    </div>
                </ng-container>
            </div>
        </div>

    </div>
</section>
<!-- end SECTION - taquets -->